import { useMediaQuery } from "@mantine/hooks";

// The CRM's one phone breakpoint: the same 768px at which DashboardLayout swaps the sidebar for
// a drawer. getInitialValueInEffect:false reads the real width on the first render, so a phone
// never flashes the desktop layout before switching. The initial value must stay undefined:
// Mantine returns a boolean initial value as it is, without asking matchMedia.
export const PHONE_QUERY = "(max-width: 768px)";
export const PHONE_MEDIA = `@media ${PHONE_QUERY}`;

export default function useIsPhone() {
  return useMediaQuery(PHONE_QUERY, undefined, { getInitialValueInEffect: false });
}
